namespace Solovis.UI {

    export class HtmlViaPostRpcControl extends Solovis.UI.BaseControl {

        public url;
        public request;
        public html;

        constructor(options) {
            super(options);

            this.url = options.url;
            this.request = options.request;
        }

        public doInitAsync() {
            var self = this;
            Solovis.Rpc.invoke(this.url, this.request,
                function (response, success) {
                    if (success) {
                        self.html = response.result.html;
                    }
                    else {
                        self.html = "Error loading view.";
                    }

                    self.notifyInitComplete();
                });
        }

        public doRender() {
            var self = this;

            this.container.html(this.html);
        }
    }

} 
